export default __webpack_public_path__ + "static/media/080_finish_soso.93ae7863.mp4";